//import { JwtService } from './JwtService';

export default class PermissionService {

    private internalPermissions: string[] = [];
    public get permissions() {
        return this.internalPermissions;
    }

    public setPermissions(permissions: string[]) {
        this.internalPermissions = permissions || [];
    }

    public hasPermission(permission: string) {
        /*if (JwtService.jwtIsAdmin()) {
            return true;
        }*/
        return this.permissions.findIndex((x) => x === permission) !== -1;
    }
}

export const ssmPermissionService = new PermissionService();
